/* eslint no-param-reassign: 0 */

const initialState = {};

const gettersDef = {};

const actions = {
  fetchSettings({ dispatch, rootGetters }, { params = {} } = {}) {
    const company = rootGetters["auth/activeCompany"];
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `/spage/settings/${company.id}`, params },
      { root: true }
    );
  },
  patchSettings({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `/spage/settings/${data.companyId}/`, data },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
